import axios from "@/api/config_php";
// import qs from 'qs'
// 样例
//导出
export const businessLicense = param =>
axios.get(`https://aip.baidubce.com/oauth/2.0/token?grant_type=${param.grant_type}&client_id=${param.API_Key}&client_secret=${param.Secret_Key}`, {},{ baseURL: "/ocr" });
